import { Graphics, Text, Container } from 'pixi.js';
import { BaseScene } from './BaseScene.js';
import { MenuScene } from './MenuScene.js';
import { DebugLog } from '../core/DebugLog.js';
import { GAME_WIDTH, GAME_HEIGHT } from '../main.js';

/**
 * Boot/title screen. Shows game title and "Press any key to start".
 */
export class BootScene extends BaseScene {
  init() {
    DebugLog.info('BootScene', 'Initializing boot screen');

    // Dark background
    const bg = new Graphics();
    bg.rect(0, 0, GAME_WIDTH, GAME_HEIGHT);
    bg.fill(0x0a0a0f);
    this.container.addChild(bg);

    // Starfield background
    this.stars = [];
    const starGfx = new Graphics();
    for (let i = 0; i < 60; i++) {
      const x = Math.random() * GAME_WIDTH;
      const y = Math.random() * GAME_HEIGHT;
      const brightness = Math.random();
      const size = Math.random() > 0.9 ? 2 : 1;
      const color = brightness > 0.7 ? 0x6666aa : brightness > 0.4 ? 0x444466 : 0x222244;
      starGfx.rect(x, y, size, size);
      starGfx.fill(color);
      this.stars.push({ x, y, speed: 0.1 + Math.random() * 0.3, brightness });
    }
    this.container.addChild(starGfx);

    // Title text
    const title = new Text({
      text: 'ASTRAL CRYPTS',
      style: {
        fontFamily: 'Courier New, monospace',
        fontSize: 24,
        fontWeight: 'bold',
        fill: 0xffdd44,
        letterSpacing: 4,
        dropShadow: true,
        dropShadowColor: 0x000000,
        dropShadowDistance: 2,
      }
    });
    title.anchor.set(0.5);
    title.x = GAME_WIDTH / 2;
    title.y = GAME_HEIGHT / 2 - 30;
    this.container.addChild(title);

    // Subtitle
    const subtitle = new Text({
      text: 'by Void Wanderer Studios',
      style: {
        fontFamily: 'Courier New, monospace',
        fontSize: 8,
        fill: 0x667788,
        letterSpacing: 2,
      }
    });
    subtitle.anchor.set(0.5);
    subtitle.x = GAME_WIDTH / 2;
    subtitle.y = GAME_HEIGHT / 2 - 8;
    this.container.addChild(subtitle);

    // Prompt
    this.prompt = new Text({
      text: 'Press ENTER to begin',
      style: {
        fontFamily: 'Courier New, monospace',
        fontSize: 10,
        fill: 0x88aacc,
      }
    });
    this.prompt.anchor.set(0.5);
    this.prompt.x = GAME_WIDTH / 2;
    this.prompt.y = GAME_HEIGHT / 2 + 40;
    this.container.addChild(this.prompt);

    // Version info
    const version = new Text({
      text: 'v0.2.0 — Milestone 2',
      style: {
        fontFamily: 'Courier New, monospace',
        fontSize: 7,
        fill: 0x334455,
      }
    });
    version.anchor.set(0.5);
    version.x = GAME_WIDTH / 2;
    version.y = GAME_HEIGHT - 12;
    this.container.addChild(version);

    this._blinkTimer = 0;

    DebugLog.info('BootScene', 'Boot screen ready');
  }

  update(dt) {
    // Blink the prompt
    this._blinkTimer += dt;
    if (this._blinkTimer > 0.5) {
      this._blinkTimer = 0;
      this.prompt.visible = !this.prompt.visible;
    }

    // Check for start input
    const input = this.sceneManager.inputManager;
    if (input.isKeyJustPressed('Enter') || input.isKeyJustPressed('Space')) {
      DebugLog.info('BootScene', 'Start pressed — transitioning to menu');
      this.sceneManager.switchTo(new MenuScene(this.sceneManager, this.eventBus));
    }
  }
}
